module.exports = __webpack_public_path__ + "img/growthScore.e7315ad5.png";